<template>
    <highcharts v-if="series.length>0" :options="options"></highcharts>
</template>

<script>
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import stockInit from 'highcharts/modules/stock'

exportingInit(Highcharts)
stockInit(Highcharts)
Highcharts.setOptions({
  lang: {
    downloadPNG: '下載成PNG',
    downloadJPEG: '下載成JPEG',
    downloadPDF: '下載成PDF',
    downloadSVG: '下載成SVG'
  },
  exporting: {
    enabled: true,
    buttons: {
      contextButton: {
        align: 'right',
        y: -5,
        x: 10,
        menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG']
      }
    }
  }
})
export default {
  name: 'DeviceChart',
  props: ['series'],
  computed: {
    options () {
      return {
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        series: this.series,
        plotOptions: {
          series: {
            animation: true,
            dataLabels: {
              enabled: true,
              style: {
                color: '#4a4a4a',
                fontSize: '12px',
                fontWeight: ' ',
                textOutline: '1px 1px contrast'
              }
            },
            marker: {
              radius: 4
            }
          }
        },
        chart: {
          type: 'pie',
          polar: false,
          style: {
            fontFamily: 'Arial',
            color: '#333',
            fontSize: '14px',
            fontWeight: 'normal',
            fontStyle: 'normal'
          },
          height: 255,
          width: null,
          backgroundColor: 'transparent'
        },
        credits: {
          enabled: false
        },
        colors: ['#FFADBA', '#00C6DB', '#FEE987'],
        legend: {
          align: 'center',
          floating: false,
          layout: 'horizontal',
          backgroundColor: 'transparent',
          verticalAlign: 'top',
          enabled: true,
          itemStyle: {
            fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Verdana, Arial, Helvetica, sans-serif',
            color: '#333333',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            textOverflow: 'ellipsis',
            cursor: 'pointer'
          },
          y: -15,
          x: 0
        },
        yAxis: [
          {
            type: 'linear',
            title: {
              text: null
            },
            labels: {
              format: '{value}%'
            }
          }
        ],
        xAxis: [
          {
            type: 'category',
            labels: {
              format: '{value}'
            },
            title: {
              text: null
            }
          }
        ],
        tooltip: {
          enabled: true,
          shared: true,
          borderWidth: 1
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
